/* eslint-disable react/react-in-jsx-scope */
import {
  ApprovedIconStatus,
  InProgressIconStatus,
  PendingIconStatus,
} from '@components';
import theme from 'config/theme';

export const STATUSES_COLORS = {
  PENDING: {
    label: 'Pending',
    value: 'PENDING',
    styles: {
      color: theme.palette.yellows.yellow900,
      alignItems: 'center',
      gap: '8px',
    },
    icon: () => <PendingIconStatus />,
  },
  IN_PROGRESS: {
    label: 'In Progress',
    value: 'IN_PROGRESS',
    styles: {
      color: theme.palette.teals.teal900,
      alignItems: 'center',
      gap: '8px',
    },
    icon: () => <InProgressIconStatus />,
  },
  FULFILLED: {
    label: 'Done',
    value: 'FULFILLED',
    styles: {
      color: theme.palette.greens.green900,
      alignItems: 'center',
      gap: '8px',
    },
    icon: () => <ApprovedIconStatus />,
  },
};

export const TYPES_COLORS = {
  Accident: {
    label: 'Accident',
    styles: {
      backgroundColor: theme.palette.reds.red200,
      color: theme.palette.reds.red900,
    },
  },
  'Car Damage': {
    label: 'Car Damage',
    styles: {
      backgroundColor: theme.palette.grays.gray300,
      color: theme.palette.grays.gray900,
    },
  },
  'Car Service': {
    label: 'Car Service',
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  'Change Tires': {
    label: 'Change Tires',
    styles: {
      backgroundColor: theme.palette.violets.violet200,
      color: theme.palette.violets.violet900,
    },
  },
  'Glass Repair': {
    label: 'Glass Repair',
    styles: {
      backgroundColor: theme.palette.fukshias.fukshia200,
      color: theme.palette.fukshias.fukshia900,
    },
  },
  'Plate Loss': {
    label: 'Plate Loss',
    styles: {
      backgroundColor: theme.palette.oranges.orange200,
      color: theme.palette.oranges.orange900,
    },
  },
  'Roadside Assistance': {
    label: 'Roadside Assistance',
    styles: {
      backgroundColor: theme.palette.yellows.yellows200,
      color: theme.palette.yellows.yellows900,
    },
  },
};
